import React from "react";
import autobind from "class-autobind";
import { ETrendTimeScope, IGroupedTrend, ITrendSearch } from "../../../models/data/dashboard/Trends/TrendsData";
import TrendDetailsHeader from "./TrendDetailsHeader";
import TrendLine from "./TrendLine";
import TrendHierarchyChildrenTable from "./TrendHierarchyChildrenTable";
import { IDate } from "../../../models";
import moment from "moment";
import TrendDayGraph from "./TrendHierarchyGraph";


interface IProps {
    selectedGroups: IGroupedTrend[] | null; 
    trendSearch: ITrendSearch;
    scope: ETrendTimeScope;
    onScopeChange(newScope: ETrendTimeScope): void;
    startDate: IDate;          
    endDate: IDate;        
    updateDateRange(startDate: IDate, endDate: IDate): void;  
    onSelectNewItem(newItem: IGroupedTrend): void;
}


interface IState {
}

export default class TrendDetails extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {};
        autobind(this);
    }
        
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps: IProps) {
        // Check if selectedGroups, startDate, or endDate have changed
        if (prevProps.selectedGroups !== this.props.selectedGroups ||
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate) {
            // Trigger re-render by updating state (even with an empty object)
            this.setState({}); 
        }
    }
    getChildItems(selectedGroups: IGroupedTrend[], leafNodes: boolean): IGroupedTrend[] {
        let returnVal = [];

        selectedGroups.forEach(selectedItem => {
            if (leafNodes) {
                returnVal = returnVal.concat(
                    this.props.trendSearch.GroupedTrends.filter(
                        item => item.LeafNode && item.Settings.Id === selectedItem.Settings.Id
                    ).sort((a, b) => (a.ObjectName > b.ObjectName ? 1 : 0))
                );
            } else {
                returnVal = returnVal.concat(
                    this.props.trendSearch.GroupedTrends.filter(
                        item =>
                            item.HierarchyId !== selectedItem.HierarchyId &&
                            item.ParentHierarchyId === selectedItem.HierarchyId &&
                            !item.LeafNode &&
                            item.Settings.Id === selectedItem.Settings.Id
                    ).sort((a, b) => (a.HierarchyName > b.HierarchyName ? 1 : 0))
                );
            }
        });

        return returnVal;
    }
    isSameScope(scope: ETrendTimeScope, startDate: moment.Moment, endDate: moment.Moment): boolean {
        switch (scope) {
            case ETrendTimeScope.Daily:
                return startDate.isSame(endDate, 'day');
            case ETrendTimeScope.Weekly:
                return startDate.isSame(endDate, 'week');
            case ETrendTimeScope.Monthly:
                return startDate.isSame(endDate, 'month');
            case ETrendTimeScope.Quarterly:
                return startDate.isSame(endDate, 'quarter');
            case ETrendTimeScope.SemiAnnualy:
                const startQuarter = Math.ceil(startDate.quarter() / 2); // Group quarters into H1 (1, 2) and H2 (3, 4)
                const endQuarter = Math.ceil(endDate.quarter() / 2);
                return startDate.isSame(endDate, 'year') && startQuarter === endQuarter;
            case ETrendTimeScope.Annualy:
                return startDate.isSame(endDate, 'year');
            default:
                return false;
        }
    }

    render() {
        const { selectedGroups, scope, trendSearch, startDate, endDate, updateDateRange } = this.props;
        const isSameScope = this.isSameScope(scope, moment(startDate), moment(endDate));
        return (
            <div style={{ padding: 5, paddingLeft: 10 }}>
                {selectedGroups && selectedGroups.length > 0 && (
                    <div>
                        <div key={`${selectedGroups[0].HierarchyId}-${selectedGroups[0].Settings.Id}`}>
                            <TrendDetailsHeader // Header for each individual trend
                                scope={scope}
                                data={selectedGroups[0]} 
                                onScopeChange={this.props.onScopeChange}
                                startDate={startDate} // Pass startDate
                                endDate={endDate} // Pass endDate
                                updateDateRange={updateDateRange} // Pass the updateDateRange function
                            />
                         <div style={{ padding: 10 }}>
                         {isSameScope ? (
                                    <TrendDayGraph
                                        groupedTrends={this.getChildItems(selectedGroups, false)}
                                        settings={selectedGroups[0].Settings}
                                    />
                                ) : (
                                    <TrendLine
                                        groupedTrends={selectedGroups}
                                        scope={scope}
                                        startDate={moment(startDate)} // Pass startDate as a Moment object
                                        endDate={moment(endDate)}   // Pass endDate as a Moment object
                                        value={(selectedGroups[0].Totals.ChangedValue) || 0}
                                        settings={selectedGroups[0].Settings}
                                        updateDateRange={updateDateRange}
                                    />
                                )}
                            </div>
                    </div>
                    {selectedGroups.map(selectedGroup => (
                        <div key={`${selectedGroup.HierarchyId}-${selectedGroup.Settings.Id}`}>
                            <div>
                                <TrendHierarchyChildrenTable 
                                    key={`${selectedGroup.HierarchyId}-${selectedGroup.Settings.Id}-nonleaf`} // Unique key for non-leaf table
                                    scope={scope} 
                                    trendSearch={trendSearch} 
                                    selectedItem={selectedGroup}
                                    leafNodes={false} 
                                />
                            </div>
                            <div>
                                <TrendHierarchyChildrenTable 
                                    key={`${selectedGroup.HierarchyId}-${selectedGroup.Settings.Id}-leaf`} // Unique key for leaf table
                                    scope={scope} 
                                    trendSearch={trendSearch} 
                                    selectedItem={selectedGroup}
                                    leafNodes={true} 
                                />
                            </div>
                        </div>
                    ))}
                    </div>
                )}
            </div>
        );
    }
}